var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"line_item"},[_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "+_vm._s(_vm.valueAmount))])
}
var staticRenderFns = []

export { render, staticRenderFns }